/**
 * Owner: Masa Bayu
 * File: ReaderProfileOrders.tsx
 * Date:Time: 2026-10-19 18:45
 * Description: §393 — seksyen Pesanan & Lesen Profil Reader: setiap item rak
 *   ialah lesen kekal (entitlement nyata) + pautan sejarah pesanan penuh.
 */

import type { ReactElement } from 'react';
import { LandingIcon } from '../home/marketplace/landing/LandingIcons';
import { safeIntlTag } from '../home/marketplace/marketplace-locale';
import type { ReaderProfileData } from './reader-profile-data';
import type { ReaderProfileLabels } from './reader-profile-labels';

function formatDate(iso: string, interfaceTag: string): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? '—'
    : d.toLocaleDateString(safeIntlTag(interfaceTag), {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
}

export function ReaderProfileOrders({
  data,
  labels,
  interfaceTag,
  onNavigate,
}: {
  readonly data: ReaderProfileData;
  readonly labels: ReaderProfileLabels;
  readonly interfaceTag: string;
  readonly onNavigate: (path: string) => void;
}): ReactElement {
  return (
    <div className="qxr__stack">
      <section className="qxr__card" aria-labelledby="qxr-orders">
        <div className="qxr__card-head">
          <h2 id="qxr-orders" className="qxr__section-title">
            <LandingIcon name="receipt" size={18} /> {labels.ordersTitle}
          </h2>
          <button type="button" className="qxr__link" onClick={() => onNavigate('/orders')}>
            {labels.fullHistory} <LandingIcon name="chevronRight" size={12} />
          </button>
        </div>
        <p className="qxr__muted">{labels.ordersHint}</p>
        {data.shelf.length === 0 ? (
          <p className="qxr__empty">{labels.emptyLibrary}</p>
        ) : (
          <ul className="qxr__rows">
            {data.shelf.map((card) => (
              <li key={`order-${card.item.libraryItemId}`}>
                <span className="qxr__rowtitle">{card.item.title}</span>
                <span className="qxr__rowmeta">
                  {labels.license} · {formatDate(card.item.updatedAt, interfaceTag)}
                  {card.item.offlineAvailable ? (
                    <>
                      {' · '}
                      <LandingIcon name="download" size={12} /> {labels.offlineReady}
                    </>
                  ) : (
                    ''
                  )}
                </span>
                {card.canOpen ? (
                  <button
                    type="button"
                    className="qxr__cta qxr__cta--ghost"
                    onClick={() =>
                      onNavigate(`/read/${encodeURIComponent(card.item.publicationId)}`)
                    }
                  >
                    {labels.openReader}
                  </button>
                ) : (
                  <span className="qxr__muted">{card.accessLabel}</span>
                )}
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
}
